var $3922685c0eb9ba8a$exports = {};
$3922685c0eb9ba8a$exports = {
    "rangeOverflow": (args)=>`Der Wert muss ${args.maxValue} oder fr\xfcher sein.`,
    "rangeReversed": `Das Startdatum muss vor dem Enddatum liegen.`,
    "rangeUnderflow": (args)=>`Der Wert muss ${args.minValue} oder sp\xe4ter sein.`,
    "unavailableDate": `Das ausgew\xe4hlte Datum ist nicht verf\xfcgbar.`
};


export {$3922685c0eb9ba8a$exports as default};
//# sourceMappingURL=de-DE.mjs.map
